function curry(fn, arity = fn.length, reverseArgs = false) {
  return (function nextCurried(prevArgs) {
    return function curried(...nextArg) {
      const args = [...prevArgs, ...nextArg]

      if (args.length >= arity) {
        return fn(...(reverseArgs ? args.reverse() : args))
      } else {
        return nextCurried(args)
      }
    }
  })([])
}

export default curry
